import { ConsumerWorkflowStepsState } from './consumer-workflow-steps-state.interface'

export function createConsumerWorkflowStepsState(): ConsumerWorkflowStepsState {
  return {
    workflowSteps: null,
    activeWorkflowStep: null,
  }
}
